import { createTheme, adaptV4Theme } from '@mui/material/styles';

const scrollBackGroudColor = '#f6f8fb';//#8c95a7 //#2b2b2b

const theme = createTheme(
    adaptV4Theme({
        overrides: {
            MuiCssBaseline: {
                "@global": {
                    body: {
                        scrollbarColor: "#6b6b6b " + scrollBackGroudColor,
                        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                            width: 10,
                            backgroundColor: scrollBackGroudColor,
                        },
                        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                            borderRadius: 8,
                            backgroundColor: "#6b6b6b",
                            minHeight: 24,
                            border: "2px solid " + scrollBackGroudColor,
                        },
                        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "#959595",
                        },
                        "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                            backgroundColor: scrollBackGroudColor,
                        }
                    }
                }
            },
            MuiGrid: {
                container: {
                    background: '#F6F8FB',
                    scrollbarColor: "#6b6b6b " + scrollBackGroudColor,
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        width: 10,
                        backgroundColor: scrollBackGroudColor,
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: "#6b6b6b",
                        minHeight: 24,
                        border: "2px solid " + scrollBackGroudColor,
                    },
                    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#959595",
                    },
                    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                        backgroundColor: scrollBackGroudColor,
                    }
                }
            },
            MuiAppBar: {
                colorPrimary: {
                    color: '#FFFFFF'                 
                }
            }
        },
        palette: {
            mode: 'light',
            primary: {
                main: '#00152a',
            },
            secondary: {
                main: '#f50057',
            },
            background: {
                default: '#F6F8FB',
            },
            error: {
                main: '#f44336',
            }
        },
        typography: {
            fontSize: 16,
            h2: {
                fontWeight: 500,
                fontSize: 20,
                fontFamily: 'roboto',
                lineHeight: 1.1,
                color: '#FFFFFF'
            },
            h3: {
                fontWeight: 'bold',
                fontSize: 48,
                fontFamily: 'roboto',
                color: '#223354'
            },
            h4: {
                fontWeight: 'bold',
                fontSize: 34,
                fontFamily: 'roboto',
                color: '#223354'
            },
            h5: {
                fontWeight: 600,
                fontSize: 24,
                fontFamily: 'roboto',
                color: '#223354'
            },
            h6: {
                fontWeight: 400,
                fontSize: 22,
                fontFamily: 'roboto',
                lineHeight: 2,
                color: '#4A4A4B'
            },
            subtitle2: {
                fontWeight: 'bold',
                fontSize: 18,
                fontFamily: 'roboto',
                lineHeight: 1,
                color: '#223354'
            },
            subtitle1: {
                fontWeight: 'bold',
                fontSize: 14,
                fontFamily: 'roboto',
                color: '#9099A9'
            },
            body1: {
                fontWeight: 400,
                fontSize: 16,
                fontFamily: 'roboto',
                color: '#223354'
            },
            body: {
                fontWeight: 400,
                fontSize: 14,
                fontFamily: 'roboto',
                lineHeight: 1,
                color: '#223354'
            }
    }
}));

export default theme;